<template>
    <div :class="(activeState ? b({active: true}) : b())">
        <div :class="b('nav')">
            <div :class="b('control-btn no-print')" @click="toggleGuide">
                <section v-if="!activeState">
                    <div class="new-icon"></div>
                    <span class="btn-text">Инструкция</span>
                </section>
                <section v-else>
                    <i class="fa fa-times"></i>
                </section>
                <!--                <i :class="`fa fa-${controlBtnIcon}`"></i>-->
            </div>
            <h2 class="h2">Инструкция по работе с торговой площадкой</h2>

            <ul class="nav nav-pills mb-3 justify-content-center" role="tablist">
                <li class="nav-item active">
                    <a class="nav-link" id="pills-home-tab" data-toggle="pill" href="#guide-buyer" role="tab" aria-controls="pills-home" aria-selected="false">Покупатель</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#guide-seller" role="tab" aria-controls="pills-profile" aria-selected="true">Поставщик</a>
                </li>
            </ul>
            <div class="tab-content">
                <div class="tab-pane fade active in" id="guide-buyer" role="tabpanel" aria-labelledby="pills-home-tab">
                    <!--                    <p class="text-muted text-center">Best results regardless of weight category</p>-->
                    <h3>1. Демо-аккаунт:</h3>

                    <p>При первом посещении сайта для знакомства с Торговой площадкой (далее ТП) вам будет предложено указать кто Вы – Покупатель или Поставщик. Нажав кнопку «Покупатель», вы попадёте в демо-аккаунт Покупателя и сможете изучить функционал ТП. Вам будет доступен Личный кабинет, Каталог товаров, Закупки и прочие сервисы. Для того, чтобы получить полный доступ к ТП и начать работу, вам нужно зарегистрироваться, нажав соответствующую кнопку в шапке страницы. Также ТП предложит вам перейти к регистрации при добавлении товара в корзину и присоединении к закупкам.</p>

                    <h3>2.	Регистрация:</h3>

                    <p>Чтобы зарегистрироваться на ТП нажмите кнопку Зарегистрироваться в всплывающем окне при входе на сайт или в шапке страницы.  Также ТП предложит вам перейти к регистрации при добавлении товара в корзину и присоединении к закупкам.</p>
                    <p>Перед Вами появится форма регистрации, которую необходимо заполнить. Установите бегунок на поле «Я покупатель», чтобы оно стало голубым. В следующих полях укажите ИНН или название организации, электронную почту и город, в который будет осуществляться доставка. Электронная почта нужна для подтверждения регистрации и получения уведомлений, поэтому используйте электронный адрес, к которому у вас есть доступ.  В поля раздела «Контактное лицо» внесите данные сотрудника, который будет отвечать за контакты с ТП. Далее вам необходимо ознакомиться с правилами пользования ТП. Для этого перейдите по ссылке к Пользовательскому соглашению и после прочтения поставьте галочку «Я согласен с правилами». Заполнив все поля, нажмите кнопку «Зарегистрироваться».</p>
                    <p>На электронную почту, указанную при регистрации Вам придёт письмо с паролем. Теперь, используя почту и пароль, вы можете войти в личный кабинет на ТП. Рекомендуем не вносить пароль вручную, а скопировать его из письма. </p>

                    <h3>3. Вход и восстановление пароля</h3>
                    <h4>Вход</h4>
                    <p>Для того, чтобы попасть в личный кабинет, нажмите кнопку «Войти» во всплывающем окне при входе на сайт или в шапке сайта. Перед Вами откроется форма, в которой необходимо ввести Ваш логин (email) и пароль, который Вам присылала ТП. Если Вы изменили свой пароль в разделе «Безопасность», то ввести нужно его.</p>
                    <h4>Восстановление пароля</h4>
                    <p>Если Вы забыли пароль, нажмите на кнопку «Восстановить пароль» и введите адрес электронной почты, указанный при регистрации. После этого ТП пришлёт Вам новый пароль.</p>

                    <h3>4.	Личный кабинет</h3>
                    <p>Личный кабинет – раздел ТП доступный только зарегистрированным покупателям. Для того, чтобы попасть в Личный кабинет, нажмите на название вашей организации в правом верхнем углу сайта. В выпадающем меню выберите один из разделов.</p>

                    <h4>Мои закупки</h4>
                    <p>В этом разделе размещены все ваши закупки:</p>
                    <p><b>Активные закупки</b> – ваши закупки, по которым в данный момент ведутся торги.</p>
                    <p><b>Закупки на модерации</b> – ваши закупки, по которым были завершены торги, и они находятся на проверке у администраторов ТП. По истечении 24 часов закупки перейдут в раздел «Закупки на исполнении».</p>
                    <p><b>Закупки на исполнении</b> – ваши закупки, торги по которым уже завершились. Закупки находятся в этом разделе до их исполнения, то есть до поставки товара.</p>
                    <p><b>Архивные закупки</b> – ваши закупки, которые были исполнены.</p>
                    <p><b>Черновик</b> – ваши закупки, которые были сформированы, но не опубликованы.</p>
                    <p> Также в разделе Мои закупки доступны следующие опции:</p>
                    <p><b>Все закупки</b> – просмотр всех актуальных закупок на ТП. К интересующей вас закупке Вы можете присоединиться, для чего в закупке нажмите на соответствующий товар. Перейдя в Карточку товара, выберите необходимые характеристики товара, его количество и нажмите кнопку «В корзину». В последующем, при публикации закупки, присоединение выполнится автоматически.</p>
                    <p><b>Прикрепить</b> – опция для отправки документов на ТП. Нажав на кнопку, Вы попадёте в форму для прикрепления документов: Потребности, Карты Партнёра, Договора.</p>

                    <h4>Мои заявки</h4>
                    <p>В этом разделе размещены ваши заявки – перечень закупок, сформированных в течение одних суток. Здесь вы можете отслеживать изменение цен в ходе торгов, а также повторять заявки, формируя закупку практически в один клик. Для этого в нужной заявке откорректируйте количество товара, если это необходимо, или удалите галочки с лишних позиций и нажмите кнопку «Повторить заявку».</p>

                    <h4>Мои данные</h4>
                    <p> Раздел содержит информацию об организации: контактные данные и реквизиты. В случае изменений они доступны редакции.</p>
                    <h4>Избранное</h4>
                    <p>В этот раздел вы можете добавить закупки, по которым хотели бы отслеживать ход торгов для дальнейшего присоединения и товары с выбранным набором характеристик. Для того, чтобы добавить закупку в раздел нажмите «Звездочку» под интересующей закупкой справа. Так же Вы можете оставлять любые комментарии под закупками, видеть их будете только вы. Чтобы добавить в избранное товар, выберите нужные характеристики и нажмите «Звездочку» в карточке товара.</p>
                    <p>Что бы удалить закупку или товар из «Избранного» нажмите на «Звездочку» ещё раз.</p>

                    <h4>Подписки</h4>
                    <p>Подключение подписок позволяет получать уведомления о публикации закупок интересующих Вас товаров и присоединяться к ним. Для этого в разделе Подписки выберите нужную подгруппу или группу товаров целиком. Из получаемых на электронную почту уведомлений вы сможете перейти в интересующую вас закупку и присоединиться к ней. По умолчанию подписка действует на все товары.</p>

                    <h4>Уведомления</h4>
                    <p>В этом разделе Вы можете настроить получение следующих уведомлений:</p>
                    <p>Размещение закупки – уведомление приходит при успешном размещении вашей закупки.</p>
                    <p>Изменение цены – уведомление приходит каждый раз, когда поставщики предлагают новую цену на товар в ходе торгов.</p>
                    <p>Изменение партии – уведомление приходит в случае присоединения участников к вашей закупке и увеличения её объема.</p>
                    <p>Завершение торгов – уведомление приходит по окончании срока, отведённого на торги по закупке. После этого закупка отправляется на модерацию и переходит в статус «На исполнении».</p>
                    <p>Завершение модерации – уведомление приходит по завершении модерации закупки. После этого на электронную почту Вы получите счет.</p>

                    <h4>Безопасность</h4>
                    <p>Безопасность – сервис смены пароля. Для смены пароля необходимо ввести старый и новый пароль.</p>

                    <h3>4.  Каталог</h3>
                    <p>Найти нужный товар можно двумя способами.</p>
                    <p>Введите название товара в поисковой строке в шапке сайта и выберите его в выпадающем списке.</p>
                    <p>Нажмите кнопку Каталог в шапке сайта. Выберете интересующий Вас раздел или воспользуйтесь поисковой строкой каталога. В выпадающем меню, выбрав интересующую Вас категорию, группу и товар, Вы попадёте в карточку товара. В ней Вы можете выбрать необходимые характеристики. </p>

                    <h3>5. Оформление закупки.</h3>
                    <p>Вы можете размещать закупки двух видов:</p>
                    <p>Стандартная закупка — это закупка, на торги по которой даётся пять рабочих дней.</p>
                    <p>Чтобы оформить закупку, поместите необходимые Вам товары в Корзину. Для этого найдите товар с помощью поиска или выберите в Каталоге и перейдите в Карточку товара. В ней Вы увидите изображение товара и его характеристики.</p>
                    <p>Основные характеристики – самые важные отличительные свойства товара, определяющие его тип и назначение. Для формирования закупки вам необходимо выбрать все указанные основные характеристики.</p>
                    <p>Дополнительные характеристики – свойства товара, которые не влияют на его функциональность, например, цвет или марка производителя. Если они важны для вас, откройте раздел «Дополнительные характеристики» и выберите нужные атрибуты. Важно, что наличие Дополнительных характеристик ограничивает круг возможных поставщиков и значительно снижает возможность объединения в Совместную закупку. </p>
                    <p>По мере выбора характеристик стартовая цена товара будет меняться.</p>
                    <p>Просмотреть активные закупки по выбранной подгруппе можно во вкладке «Закупки по товару». Товары из той же группы, что и выбранный вами товар, находятся во вкладке «Сопутствующие товары».</p>
                    <p>Выбрав в Карточке товара характеристики, укажите необходимое количество товара, при этом, обязательно обратите внимание на единицы измерения. Если выбранное количество товара не кратно упаковке, по результатам торгов оно будет автоматически изменено до ближайшего кратного значения. Чтобы добавить товар в Корзину, нажмите соответствующую кнопку.</p>
                    <p>После того, как все товары будут добавлены, Вам нужно перейти в Корзину. Здесь Вы можете проверить выбранный товар и, при необходимости, скорректировать количество позиций. Далее определите тип планируемой закупки: стандартная или срочная. В разделе Информация о закупке отобразится общее количество товаров, стартовая цена и срок завершения торгов. Перечень товаров и информацию о закупке можно распечатать, выгрузить в формате Excel или отправить на почту.</p>
                    <p>Для того, чтобы разместить закупку на ТП в открытом доступе для начала торгов, нажмите кнопку «Опубликовать закупку». Если Вы хотите опубликовать закупку позже или планируете внести какие-либо изменения в перечень товаров нажмите кнопку «Сохранить в черновик». Черновик закупки будет доступен в соответствующем разделе Личного кабинета. Если вы не хотите размещать эту закупку, её можно удалить. Опубликованная закупка отобразится в разделе Активные закупки Личного кабинета.</p>

                    <h3>6. Прикрепление потребности</h3>
                    <p>Для Вашего удобства ТП может оформить закупку необходимых товаров на основе вашей Потребности. В личном кабинете, нажмите кнопку Прикрепить и загрузите файл с перечнем. Когда закупка по Вашей потребности будет сформирована и размещена в Корзине, вы получите соответствующее уведомление на почту. Проверьте сформированную закупку в корзине и нажмите кнопку «Опубликовать закупку».</p>

                    <h3>7. Совместные закупки</h3>
                    <p>ТП позволяет покупателям объединяться в совместные закупки.</p>
                    <p>Совместная закупка – закупка, при которой несколько покупателей приобретают один и тот же товар у одного поставщика. Таким образом, объем заявки увеличивается, а цена за единицу товара за счёт этого уменьшается. Срок проведения торгов отсчитывается от даты публикации первой закупки, в остальном закупка проходит по стандартам ТП и не отличается от одиночной.</p>
                    <p>Найти закупки для присоединения можно несколькими способами:</p>
                    <p>•	В разделе «Мои закупки» Личного кабинета нажмите на кнопку «Все закупки». </p>
                    <p>•	Нажмите кнопку «Закупки» в шапке сайта.</p>
                    <p>•	Перейдите во вкладку «Сопутствующие закупки» в Карточке товара, чтобы увидеть активные закупки по выбранной подгруппе товаров. </p>
                    <p>•	Получив уведомление по подписке, перейдите в предложенную закупку. </p>
                    <p>Выберите подходящий товар, нажмите кнопку «Присоединиться» и укажите необходимое Вам количество товаров в появившемся окошке. Затем нажмите кнопку «Принять» или «Отменить».</p>
                    <p>После формирования собственной закупки в Корзине, при наличии закупки с аналогичными товарами, ТП сама объединит Ваши закупки.</p>

                    <h3>8. Торги</h3>
                    <p>Торги по закупке проходят в режиме аукциона, каждое последующее ценовое предложение от поставщика должно быть ниже предыдущего. Узнавать об изменениях цены в ходе торгов Вы сможете, подключив соответствующее Уведомление в Личном кабинете. Торги завершатся по истечении регламентированного срока, и закупка перейдёт на модерацию, которая займёт не более 24 часов.  Если ценовое предложение Вас не устраивает, в течение 24 часов с момента закрытия закупки Вы можете отказаться от закупки, и она будет признана несостоявшейся.  </p>

                    <h3>9. Ответственность перед ТП</h3>
                    <p>Размещая закупки на ТП, Вы принимаете на себя обязательства по инициации торгов. </p>
                    <p>В случае, если ТП не обеспечила снижение цены на товар, Вы можете отказаться от него без каких-либо последствий в течение 24 часов после закрытия закупки.</p>
                    <p>Если цена на товар снизилась относительно стартовой, отказ от закупки подразумевает ответственность в виде попадания в реестр недобросовестных покупателей на 30 календарных дней. Находясь в реестре, Вы можете оформлять закупки при условии невозвратной предоплаты в размере 10% от стартовой стоимости товаров. В день размещения закупки Покупатель получает соответствующий счёт, обязательный к оплате в течение двух рабочих дней. В случае, если Покупатель, находящийся в реестре, не вносит предоплату или вновь отказывается от приобретения товаров соответствующего заявке Покупателя, дополнительно на него накладывается штраф в размере 10% от стоимости закупки, а возможность публикации закупок блокируется на 30 календарных дней.</p>

                    <h3>10. Оплата и получение товара</h3>
                    <p>После завершения сделки, на указанную электронную почту контактного лица Вы получите договор, заявку с перечнем товаров и счёт на их оплату. Скан подписанного договора и заявки нужно отправить на ТП, а счёт оплатить. Если договор с поставщиком уже был заключен ранее, ТП оповестит вас об этом, и подписать нужно будет только заявку. Срок оплаты не регламентирован, но заявленный период доставки отсчитывается с момента поступления денег на счёт поставщика. При возникновении вопросов, дополнительно с Вами может связаться менеджер ТП. После подписания договора, заявки и оплаты счёта, в течение семи рабочих дней вы получите товар на ближайший к Вам терминал транспортной компании или на адрес организации, в зависимости от условий поставки. Доставка до терминала для покупателя бесплатна.</p>
                    <h3>11. Акции</h3>
                    <p>В разделе Акции регулярно появляются предложения со скидками от поставщиков ТП. Если они интересны Вам, нажмите на соответствующий товар и заполните форму обратной связи, после чего с Вами свяжется менеджер ТП и оформит закупку.</p>

                    <h3>12. Документооборот</h3>
                    <p>Поставка товара осуществляется на основании подписанного договора, заявки, содержащей наименование и количества Товара, заказанного покупателем и счета, оплаченного покупателем. Необходимые документы формирует торговая площадка и отправляет Покупателю и Поставщику на подпись. Мы настоятельно рекомендуем использовать установленную форму договора, которая в равной степени защищает интересы Покупателя и Поставщика. Ознакомиться с договором можно в футере (нижней части) сайта.</p>

                    <h3>13. Проблемы и рекламация</h3>
                    <p>В случае возникновения проблем на любом из этапов, мы будем рады помочь Вам преодолеть их. Для этого напишите нам на help@medvedmarket.com, воспользуйтесь формой обратной связи на сайте или позвоните на горячую линию по номеру 8 800 555 11 20.</p>
                    <br>
                    <br>
                    <br>
                </div>
                <div class="tab-pane fade" id="guide-seller" role="tabpanel" aria-labelledby="pills-profile-tab">
                    <h3>1.	Демо-аккаунт</h3>

                    <p>При первом посещении сайта для знакомства с Торговой площадкой (далее ТП) вам будет предложено указать кто Вы – Покупатель или Поставщик. Нажав кнопку «Поставщик», вы попадёте в демо-аккаунт Поставщика и сможете изучить функционал ТП. Вам будет доступен Личный кабинет, Каталог товаров, Закупки и прочие сервисы. Для того, чтобы получить полный доступ к ТП и начать работу, вам нужно зарегистрироваться, нажав соответствующую кнопку в шапке страницы. Также ТП предложит вам перейти к регистрации при подаче ценового предложения.</p>

                    <h3>2.	Регистрация:</h3>

                    <p>Чтобы зарегистрироваться на ТП нажмите кнопку Зарегистрироваться во всплывающем окне при входе на сайт или в шапке страницы.  Также ТП предложит вам перейти к регистрации при подаче ценового предложения.</p>
                    <p>Перед Вами появится форма регистрации, которую необходимо заполнить. Установите бегунок на поле «Я поставщик», чтобы оно стало голубым. В следующих полях укажите ИНН или название организации, электронную почту и город нахождения. Электронная почта нужна для подтверждения регистрации и получения уведомлений, поэтому используйте электронный адрес, к которому у вас есть доступ.  В поля раздела «Контактное лицо» внесите данные сотрудника, который будет отвечать за контакты с ТП. Далее вам необходимо ознакомиться с правилами пользования ТП. Для этого перейдите по ссылке к Пользовательскому соглашению и после прочтения поставьте галочку «Я согласен с правилами». Заполнив все поля, нажмите кнопку «Зарегистрироваться».</p>
                    <p>На электронную почту, указанную при регистрации Вам придёт письмо с паролем. Теперь, используя почту и пароль, вы можете войти в личный кабинет на ТП. Рекомендуем не вносить пароль вручную, а скопировать его из письма. </p>

                    <h3>3. Вход и восстановление пароля</h3>
                    <h4>Вход</h4>
                    <p>Для того, чтобы попасть в личный кабинет, нажмите кнопку «Войти» во всплывающем окне при входе на сайт или в шапке сайта. Перед Вами откроется форма, в которой необходимо ввести Ваш логин (email) и пароль, который Вам присылала ТП. Если Вы изменили свой пароль в разделе «Безопасность», то ввести нужно его. </p>
                    <h4>Восстановление пароля</h4>
                    <p>Если Вы забыли пароль, нажмите на кнопку «Восстановить пароль» и введите адрес электронной почты, указанный при регистрации. После этого ТП пришлёт Вам новый пароль.</p>
                    <h3>4.	Личный кабинет</h3>
                    <p>Личный кабинет – раздел ТП доступный только зарегистрированным поставщикам. Для того, чтобы попасть в Личный кабинет, нажмите на название вашей организации в правом верхнем углу сайта. В выпадающем меню выберите один из разделов.</p>
                    <h4>Мои закупки</h4>
                    <p>В этом разделе размещены все ваши закупки:</p>
                    <p><b>Активные закупки</b> – закупки, по которым Вы давали ценовые предложения и на данный момент торги продолжаются.</p>
                    <p><b>Закупки на модерации</b> –закупки, в которых вы стали победителям по завершении торгов, находящиеся на проверке у администраторов ТП. По истечении 24 часов закупки перейдут в раздел «Закупки на исполнении».</p>
                    <p><b>Закупки на исполнении</b> – закупки, торги по которым уже завершились, и Вы стали победителем. В этом разделе существует фильтр по статусам, которые вы сами можете присваивать закупкам.</p>
                    <p><b>Архивные закупки</b> – закупки, которые были исполнены Вами.</p>
                    <p><b>Все закупки</b> – просмотр всех закупок на ТП, по которым идут торги. </p>

                    <h4>Мои данные</h4>
                    <p>Раздел содержит информацию об организации: контактные данные и реквизиты. В случае изменений они доступны редактированию.</p>
                    <h4>Избранное</h4>
                    <p>В этот раздел вы можете добавить закупки, по которым хотели бы отслеживать ход торгов для дальнейшего участия или мониторинга цен. Для того, чтобы добавить закупку в раздел нажмите «Звездочку» под интересующей закупкой справа. Так же Вы можете оставлять любые комментарии под закупками, видеть их будете только вы.</p>
                    <p>Что бы удалить закупку из «Избранного» нажмите на «Звездочку» под закупкой ещё раз.</p>
                    <h4>Подписки</h4>
                    <p>Подключение подписок позволяет получать уведомления о публикации закупок интересующих Вас товаров. Для этого в разделе Подписки выберите нужную группу или категорию товаров целиком. Из получаемых уведомлений вы сможете перейти в интересующую вас закупку и предложить свои цены. </p>

                    <h4>Уведомления</h4>
                    <p>В этом разделе Вы можете настроить получение следующих уведомлений:</p>
                    <p>Изменение цены – уведомление приходит каждый раз, когда другие поставщики предлагают новую цену на товар в ходе торгов.</p>
                    <p>Изменение партии – уведомление приходит в случае, если в закупке, на которую вы дали предложение, изменилось количество товара. Это может произойти в случае, если покупатель увеличил объем самостоятельно или к закупке присоединились другие покупатели.</p>
                    <p>Завершение торгов – уведомление приходит по окончании срока, отведённого на торги по закупке. </p>
                   <p>Закрытие модерации – уведомление приходит после завершения модерации в случае, если Вы стали победителем в торгах. </p>

                    <h4>Безопасность</h4>
                    <p>Безопасность – сервис смены пароля. Для смены пароля необходимо ввести старый и новый пароль.</p>

                    <h3>4.  Каталог</h3>
                    <p>Нажмите кнопку Каталог в шапке сайта. Выберете интересующий Вас раздел или воспользуйтесь поисковой строкой каталога. В выпадающем меню, выбрав интересующую Вас категорию, группу и товар, Вы попадёте в карточку товара. В ней Вы можете выбрать необходимые характеристики. </p>
                    <p>Поставщику важно ознакомиться со структурой каталога и карточкой товара, чтобы понять по какому принципу покупатель выбирает товар и формирует закупку.</p>
                    <p>Просмотреть активные закупки по выбранной подгруппе можно во вкладке «Сопутствующие закупки». Товары из той же группы, что и выбранный вами товар, находятся во вкладке «Сопутствующие товары».</p>
                    <h3>5. Участие в Торгах</h3>
                    <p>Для того чтобы участвовать в Торгах, выберите закупку, которая Вам интересна. Количество закупок, в торгах по которым Вы можете участвовать одновременно не ограничено. Найти нужную закупку можно несколькими способами:</p>
                    <p>•	Войдите в раздел Поиск закупок, нажав соответствующую кнопку в шапке сайта или нажмите кнопку «Все закупки» в разделе Мои закупки Личного кабинета. Для поиска нужной закупки выберете критерии в левой части страницы или введите конкретный товар в поисковой строке.</p>
                    <p>•	Введите название товара, закупки по которому вас интересуют, в поисковой строке в шапке сайта и выберите его в выпадающем списке</p>
                    <p>•	Нажмите кнопку «Закупки» в шапке сайта или нажмите кнопку «Все закупки» в разделе Мои закупки Личного кабинета. Для поиска нужной закупки выберете критерии в левой части страницы или введите конкретный товар в поисковой строке.</p>
                    <p>•	Получив уведомление по подписке, перейдите в предложенную закупку. </p>
                    <p>•	В карточке товара перейдите к закупкам по интересующей вас группе товаров.</p>
                    <p>При выборе закупки для участия в торгах Вам доступна следующая информация о ней:</p>
                    <p>•	Количество покупателей и города их нахождения</p>
                    <p>•	Перечень товаров (в случае, если товаров более трёх, в режиме просмотра отобразятся первые три значения)</p>
                    <p>•	Общая стоимость закупки на данный момент, с учётом текущих предложений от поставщиков</p>
                    <p>•	Количество единиц товара</p>
                    <p>•	Срок окончания торгов с обратным отсчётом</p>
                    <p>Кликните на заинтересовавшую вас закупку, чтобы получить более подробную информацию и участвовать в торгах.</p>
                    <p>В блоке «Общая информация» вы можете ознакомиться с параметрами закупки, а также распечатать их, выгрузить в формате Excel или отправить на электронную почту.</p>
                    <p>В блоке «Информация об объекте закупки» вы увидите количество товаров и текущую цену на каждый из них, то есть последнее на данный момент ценовое предложение от других поставщиков. Над каждой ценой указан диапазон, в котором Вы можете давать своё предложение, за один шаг снизить цену можно на сумму, составляющую от 0,5% до 20% от текущего предложения.  Для этого установите курсор на соответствующее поле и укажите цену вручную или с помощью скролла на каждую позицию закупки. Обратите внимание, что цена за единицу товара включает цену доставки, налогов и т.д.  После этого нажмите кнопку «Отправить предложение». Предложения будут приняты только в том случае, если Вы проставили цены на все товары закупки. Поля, ценовые предложения по которым были приняты ТП, окрашиваются в серый цвет. После каждого шага Поставщиков к сроку окончания торгов автоматически добавляется пять минут. Это позволяет избежать технических сложностей при одновременной подаче предложений от нескольких поставщиков.</p>
                    <p>Нажав «Подробнее об участниках» Вы увидите количество покупателей, города нахождения и количество товаров, которые закупает каждый из них. </p>
                    <p>Наблюдать за ходом торгов можно на сайте в режиме онлайн или с помощью соответствующих уведомлений, настроив их в Личном кабинете. </p>
                    <p>После завершения закупки в случае победы Вы получите соответствующее уведомление. </p>

                    <h3>6. Совместные закупки</h3>
                    <p>ТП позволяет покупателям объединяться в совместные закупки.</p>
                    <p>Совместная закупка – закупка, при которой несколько покупателей приобретают один и тот же товар у одного поставщика, таким образом, увеличивая объем закупки. Срок проведения торгов отсчитывается от даты публикации первой закупки, в остальном закупка проходит по стандартам ТП и не отличается от одиночной. Объединяться в закупку могут товары только одной категории.</p>

                    <h3>7. Акционный товар</h3>
                    <p>Если Вы хотите разместить Ваш товар в разделе Акции по специальной цене, нажмите кнопку Разместить товар и с вами свяжется менеджер ТП.</p>

                    <h3>8. Оплата и отправка товара</h3>
                    <p>В случае если Вы стали победителем торгов, Вам будет выслан договор и заявка с перечнем товаров. Документы необходимо подписать и выслать сканы в ответном письме вместе со счётом в течение 24 часов. Если Договор с покупателем уже был подписан раньше, ТП предупредит Вас об этом и подписать нужно будет только заявку.</p>
                    <p>Оригиналы документов направляются вместе с грузом. </p>
                    <p>После поступления денежных средств на счет в течение семи рабочих дней вам необходимо доставить товар на терминал транспортной компании в городе Покупателя.</p>

                    <h3>9. Плата за пользование ТП</h3>
                    <p>Расчётный период за пользование ТП составляет один месяц. Ежемесячно, первого числа месяца, следующего за расчётным, Вам на электронную почту будет направляться счёт, который подлежит оплате до 10 числа каждого месяца. В случае если оплата не была произведена в срок, ТП блокирует пользователя и участие в торгах становится невозможным. </p>
                    <p>Плата за пользование ТП составляет 3% от объёма продаж Вашей компании на ТП за расчётный период. К расчёту принимаются все сделки на ТП, по которым была произведена оплата.</p>

                    <h3>10. Обязательства перед ТП</h3>
                    <p>Участвуя в торгах и предлагая цену на товар, Вы берете на себя обязательства по его поставке в случае победы, поэтому, если по вине Поставщика поставка не возможна (отсутствие товара или его необходимого количества, невозможность поставки в указанный срок, не соответствие товара заявленным характеристикам и т.д.) с него удерживается 3% от стоимости не исполненной закупки в качестве штрафа за несоблюдение правил ТП.</p>
                    <p>За несоблюдение сроков по выставлению счетов, предоставлению документации, а также несоблюдения сроков поставки, поставщику начисляется пеня в размере 0,5% от общей суммы просрочки каждый день.</p>

                    <h3>11. Документооборот</h3>
                    <p>Поставка товара осуществляется на основании подписанного договора, заявки, содержащей наименование и количества Товара, заказанного покупателем и счета, оплаченного покупателем. Необходимые документы формирует торговая площадка и отправляет Покупателю и Поставщику на подпись. Мы настоятельно рекомендуем использовать установленную форму договора, которая в равной степени защищает интересы Покупателя и Поставщика. Ознакомиться с договором можно в футере (нижней части) сайта.</p>

                    <h3>12. Проблемы и рекламация</h3>
                    <p>В случае возникновения проблем на любом из этапов, мы будем рады помочь Вам преодолеть их. Для этого напишите нам на help@medvedmarket.com, воспользуйтесь формой обратной связи на сайте или позвоните на горячую линию по номеру 8 800 555 11 20.</p>

                    <br>
                    <br>
                    <br>
                </div>
                <img id="header_logo" src="/images/logo_black.png" alt="MEDVED">
            </div>
            <!--            <ul :class="b('list')">-->
            <!--                <li :class="b('list-item')" v-for="category in categories">-->
            <!--                    <span :class="b('link')" @click="openContent(category.id)">{{ category.title }}</span>-->
            <!--                    <ul :class="b('child-list')" v-if="category.children">-->
            <!--                        <li :class="b('child-item')" v-for="item in category.children">-->
            <!--                            <span :class="b('link')" @click="openContent(item.id)">{{ item.title }}</span>-->
            <!--                            <ul :class="b('child-list')" v-if="item.children">-->
            <!--                                <li :class="b('child-item')" v-for="subitem in item.children">-->
            <!--                                    <span :class="b('link')" @click="openContent(subitem.id)">{{ subitem.title }}</span>-->
            <!--                                </li>-->
            <!--                            </ul>-->
            <!--                        </li>-->
            <!--                    </ul>-->
            <!--                </li>-->
            <!--            </ul>-->
        </div>
        <!--        <div :class="(content ? b('content', {active: true}) : b('content'))">-->
        <!--            <div :class="b('back-btn')" @click="cleanContent">-->
        <!--                <i class="fa fa-angle-left"></i> <span>к навигации</span>-->
        <!--            </div>-->
        <!--            <div v-html="HTMLcontent"></div>-->
        <!--        </div>-->
    </div>
</template>

<script>
    import GuideService from '../services/GuideService';

    const COMPONENT_NAME = 'guide';

    export default {
        name: COMPONENT_NAME,
        props: ['usertype'],
        data() {
            return {
                categories: [],
                content: "",
                title: '',
                navOpen: false,
                activeState: false,
                HTMLcontent: null,
                prevCat: '',
                nextCat: '',
            }
        },
        mounted() {
            this.getCategories();

        },
        computed: {
            controlBtnIcon() {
                return (this.activeState) ? 'times' : 'question';
            }
        },
        methods: {
            async getCategories() {
                let response = await GuideService.getCategories();

                if (response.success) {
                    const categories = response.categories.filter((category) => {
                        return category.users.includes('all') || category.users.includes(this.usertype);
                    });

                    this.categories = categories;
                }
            },
            async openContent($categoryId, $openNav = false) {
                let response = await GuideService.getCategoryContent($categoryId);
                if (response.success) {
                    this.content = response.content;
                    this.HTMLcontent = response.content;
                    this.title = response.title;
                    if ($openNav) this.navState();
                    if (response.prev) {
                        this.prevCat = response.prev;
                    } else {this.prevCat = '';}
                    if (response.next) {
                        this.nextCat = response.next;
                    } else {this.nextCat = '';}
                }
            },
            toggleGuide() {
                let jivo = $('#jvlabelWrap, .wrap_mW');
                this.activeState = !this.activeState;
                this.cleanContent();
                this.activeState && jivo ? jivo.css({ 'display': 'none', }) : jivo.css({ 'display': 'unset', });
            },
            cleanContent() {
                this.content = '';
                this.HTMLcontent = '';
                this.prevCat = '';
                this.nextCat = '';
                this.navOpen = false;
            },
            navState() {
                this.navOpen = !this.navOpen;
            },
            nextCategory() {
                this.openContent(this.nextCat.id);
                if (this.navOpen) this.navState();
            },
            prevCategory() {
                this.openContent(this.prevCat.id);
                if (this.navOpen) this.navState();
            },
            askMore() {
              jivo_api.open();
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../scss/helpers/helpers';

    .guide {
        position: fixed;
        top: 0;
        right: 0;
        width: 100%;
        max-width: 650px;
        z-index: $z-top;
        height: 100vh;
        overflow: hidden;
        transform: translateX(calc(100% - 70px));
        transition: all 0.15s ease-out;

        &::-webkit-scrollbar {
            width: 5px;
            background-color: $grey40;
        }
        &::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 2px rgba(0,0,0,0.3);
            background-color: $grey40;
            border-radius: $border-radius;
        }
        &::-webkit-scrollbar-thumb {
            background-color: $blue-bg;
            border: 5px solid $blue-bg;
            border-radius: $border-radius;
        }

        &_active {
            transform: translateX(0);
            transition: all 0.35s ease-out;
        }
    }

    .guide__header {
        padding-top: 2vh;
        padding-bottom: 2vh;
        padding-left: 40px;
        font-size: 3vh;
        height: 8vh;
    }

    .guide__nav {
        margin-left: 70px;
        background: $light-color;
        padding: 10px 20px;
        height: 100vh;
        overflow-x: hidden;
        overflow-y: auto;
        box-shadow: 0px 0px 5px 2px $grey50;

        @include tablet-up {
            padding: 30px 40px;
        }
    }

    .guide__list {
        padding-left: 0;
        list-style: none;
    }

    .guide__list-item {
        font-weight: 700;
        margin-bottom: 20px;
    }

    .guide__child-list {
        margin-top: 10px;
        margin-bottom: 15px;
        list-style: none;
        font-size: 14px;
        padding-left: 20px;
    }

    .guide__child-item {
        font-weight: 400;
        margin-bottom: 5px;
        position: relative;
        padding-left: 12px;

        &::before {
            position: absolute;
            top: 3px;
            left: 0;
            content: "\f0da";
            font-family: Fontawesome, sans-serif;
            font-size: 12px;
            color: $blue-bg;
        }
    }

    .guide__link {
        color: $blue-bg;

        &:hover {
            color: $primary-color;
            cursor: pointer;
            transition: all 0.35s ease-out;
        }
    }

    .new-icon {
        background-image: url("/../images/question.png");
        background-size: cover;
        background-repeat: no-repeat;
        width: 30px;
        height: 30px;
        margin: auto;
    }

    .guide__control-btn {
        position: absolute;
        top: 40px;
        left: 2px;
        background: $light-color;
        width: 68px;
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top-left-radius: $border-radius;
        border-bottom-left-radius: $border-radius;
        font-size: 18px;
        border: 1px solid #ddd;
        border-right: none;

        &:hover {
            //box-shadow: -3px 0px 5px 1px rgba(122, 122, 122, 0.5);
            //color: lighten($primary-color, 20);
            color: #009eff;
            cursor: pointer;
            /*transition: all 0.35s ease-out;*/
        }
    }

    .btn-text {
        font-size: 10px;
    }

    .guide__content {
        margin-left: 70px;
        background: $light-color;
        width: calc(100% - 70px);
        height: 88vh;
        position: absolute;
        top: 0;
        bottom: 15vh;
        left: 0;
        transform: translateX(100%);
        transition: all 0.15s ease-out;

        &_active {
            transform: translateX(0);
            transition: all 0.25s ease-out;
        }
        &_activeNav {
            transform: translateX(50%);
            transition: all 0.35s ease-out;
        }

        .guide__back-btn {

            span {
                line-height: 1;
                color: #333333;
                font-size: 20px;
                position: relative;
                margin-top: 10px;
                margin-left: 10px;
                &:hover {
                    color: lighten($primary-color, 20);
                    transition: all .35s ease-out;
                    cursor: pointer;
                }
            }
        }
    }

    .content-inner {

        overflow-x: hidden;
        overflow-y: auto;
        top: 40px;
        width: 100%;
        padding: 0 20px 10px;
        height: calc(100% - 40px - 8vh);

        @include tablet-up {
            padding: 0 40px 20px;
        }

        &::-webkit-scrollbar {
            width: 5px;
            /*<!--background-color: $grey40;-->*/
        }
        &::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 2px rgba(0,0,0,0.3);
            /*<!--background-color: $grey40;-->*/
            border-radius: $border-radius;
        }
        &::-webkit-scrollbar-thumb {
            background-color: $grey40;
            border: 5px solid $grey40;
            border-radius: $border-radius;
        }

    }

    .nav-header {
        display: flex;
        top: 0;
        left: 0;
        width: 100%;
        height: 41px;
        padding: 0;
        border-bottom: 1px solid #cccccc;

        #header_logo {
            height: 30px;
            align-self: center;
            margin: auto;
        }
    }

    .guide__nav-menu {
        margin-left: 70px;
        background: $light-color;
        padding: 15px 10px 10px;
        width: calc(60% - 70px);
        height: 88vh;
        position: absolute;
        top: 0;
        left: 0;
        transform: translateX(calc(160% + 70px));
        transition: all 0.35s ease-out;
        overflow-x: hidden;
        overflow-y: auto;

        @include tablet-up {
            padding: 20px;
        }

        &_active {
            transform: translateX(0);
            transition: all 0.45s ease-out;
        }

        .guide__back-btn {
            font-size: 18px;
            line-height: 1;
            margin-bottom: 15px;
            /*<!--color: $primary-color;-->*/

            &:hover {
                color: lighten($primary-color, 20);
                transition: all .35s ease-out;
                cursor: pointer;
            }

            span {
                font-size: 14px;
                position: relative;
                top: -1px;
                margin-left: 7px;
            }
        }
    }

    .guide__footer {
        margin-left: 70px;
        margin-top: 5px;
        padding: 4vh;
        background: $light-color;
        width: calc(100% - 70px);
        height: 12vh;
        position: absolute;
        bottom: 0;
        left: 0;
        transform: translateX(100%);
        transition: all 0.15s ease-out;
        border-top: 1px solid #cccccc;
        text-align: center;
        display: flex;

        .ask-more {
            position: fixed;
            left: 35%;
            width: 30%;
            right: 35%;
            font-size: smaller;
        }

        .next {
            position: fixed;
            right: 5%;
            width: 30%;
        }

        .prev {
            position: fixed;
            left: 5%;
            width: 30%;
        }

        &_active {
            transform: translateX(0);
            transition: all 0.25s ease-out;
        }
    }
</style>